import { data } from 'react-router'
import { prisma } from '#app/utils/db.server.ts'
import { ReorderSchema } from '#app/utils/schemas/reorder-schema.tsx'
import { getModelByTable } from '#app/utils/table-names.ts'
import { type Route } from './+types/ordering.tsx'

export async function action({ request }: Route.ActionArgs) {
	const formData = await request.formData()
	const raw = formData.get('data')
	if (typeof raw !== 'string')
		return data({ error: 'missing data' }, { status: 400 })

	const parsed = ReorderSchema.safeParse(JSON.parse(raw))
	if (!parsed.success) return data({ error: 'invalid data' }, { status: 400 })

	const { items, table } = parsed.data

	await prisma.$transaction(async (tx) => {
		const model = getModelByTable(tx, table)

		await Promise.all(
			items.map(({ id, position }) =>
				model.update({ where: { id }, data: { position } }),
			),
		)
	})

	return { success: true }
}

export default () => null
